import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import appUrls from "../../config/appUrls";
import TweetBar from "../TweetBar";
import SwitchTweet from "../SwitchTweet";
import CloseIcon from "../icons/Close";

import { handleLikeTweet } from "./data/actions";

const LeftContainer = styled.div`
  top: 0;
  bottom: 0;
  min-height: 100vh;
  left: 0;
  z-index: 2;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  width: 23.5%;
  background-color: ${props => props.theme.backgroundSecondary};
  transition: background-color ease 1s;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 1800px) {
    width: 22.7%;
  }
  @media (max-width: 575px) {
    visibility: ${props => (props.mobileOpen ? "visible" : "hidden")};
    background-color: ${props => props.theme.background};
    width: 90%;
    right: ${props => (props.mobileOpen ? 0 : "-100%")};
    transition: right 0.4s ease-in-out, visibility 0.4s ease-in-out;
    left: inherit;
    z-index: 7;
  }
`;

const Title = styled.div`
  font-size: ${props => (props.isBig ? "20px" : "15px")};
  text-align: right;
  font-family: ${props => (props.isBig ? "dubai-medium" : "inherit")};
  margin: ${props => (props.isBig ? "34px 22px 25px" : "34px 22px 12.5px")};
  color: ${props => props.theme.textHighlight};

  @media (min-width: 1800px) {
    font-size: 21px;
    margin: 40px 44px 15px;
    line-height: 23px;
  }
  @media (max-width: 575px) {
    font-family: "dubai-bold";
    font-size: 18px;
    margin: 43px 22px 25px;
    display: flex;
    justify-content: space-between;
  }
`;

const SubTitle = styled.div`
  color: ${props => props.theme.text};
  font-size: 12px;
  line-height: 21px;
  text-align: right;
  margin: 0 22px 32px;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 26px;
    margin: 0 45px 30px;
  }
  @media (max-width: 575px) {
    display: none;
  }
`;

const MobileOnlyCloseIcon = styled(CloseIcon)`
  @media (min-width: 575px) {
    display: none;
  }
`;

class TweetArea extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      pathname,
      onReplyClick,
      mobileOpen,
      onMobileClose,
      tweets,
      handleLike
    } = this.props;
    return (
      <LeftContainer mobileOpen={mobileOpen}>
        <Title isBig={pathname === appUrls.ENTITY_ZOOMED}>
          <MobileOnlyCloseIcon
            thin
            secondary
            onClick={() => onMobileClose(false)}
          />
          أخر التحديثات الحكومية
        </Title>
        {pathname === appUrls.ENTITY_ZOOMED ? (
          <SwitchTweet />
        ) : (
          <SubTitle>
            احدث انجازات الجهات الحكومية في تحسين اداء الخدمات. يمكن التواصل مع
            الجهات من خلال الضغط على الاعجاب او الرد على التغريدة
          </SubTitle>
        )}
        {tweets.map(tweet => (
          <TweetBar
            key={tweet.id}
            onReplyClick={onReplyClick}
            tweet={tweet}
            onLike={() => handleLike(tweet.id)}
          />
        ))}
      </LeftContainer>
    );
  }
}

const mapStateToProps = state => ({
  pathname: state.router.location.pathname,
  tweets: state.tweets.tweets
});

export default connect(
  mapStateToProps,
  { handleLike: handleLikeTweet }
)(TweetArea);
